import React from "react";

export default function Card({ children }) {
  return (
    <div className="flex  shadow-xl z-10   items-center w-[90%] lg:w-[70%] h-[700px]  justify-center">
      {children}
    </div>
  );
}
